.church-page {
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: #fff;
  color: #1d1d1f;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  --bb-ink: #1d1d1f;
  --bb-copy: #646469;
}
.church-page * {
  box-sizing: border-box;
}
.church-scroll {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  scroll-behavior: smooth;
}
.church-content {
  max-width: 1200px;
  margin: auto;
  padding: 0 40px;
}
.church-page h1,
.church-page h2,
.church-page h3,
.church-page p,
.church-page figure {
  margin: 0;
}
.church-page p {
  color: #646469;
  line-height: 1.65;
}
.church-page a {
  color: inherit;
}
.church-eyebrow {
  font-size: 12px !important;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #68686d !important;
}
.church-hero {
  text-align: center;
  padding: 136px 0 70px;
}
.church-hero h1 {
  font-size: clamp(58px, 7.8vw, 94px);
  line-height: 1.02;
  letter-spacing: -0.065em;
  font-weight: 650;
  margin: 25px 0;
}
.church-hero h1 span {
  color: #86868b;
}
.church-lede {
  font-size: clamp(23px, 3vw, 30px);
  line-height: 1.28 !important;
  letter-spacing: -0.025em;
  color: #1d1d1f !important;
  font-weight: 500;
}
.church-intro {
  max-width: 635px;
  margin: 22px auto 0 !important;
  font-size: 17px;
}
.church-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 28px 0 16px;
}
.church-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
  min-height: 50px;
  padding: 14px 24px;
  background: #1d1d1f;
  color: #fff !important;
  border: 1px solid #1d1d1f;
  border-radius: 999px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  transition: opacity 0.18s;
}
.church-cta:hover {
  opacity: 0.8;
}
.church-cta-secondary {
  background: #fff;
  color: #1d1d1f !important;
  border-color: #d2d2d7;
}
.church-fine {
  font-size: 12px !important;
  line-height: 1.65 !important;
}
.church-content h2[id] {
  scroll-margin-top: 96px;
}
.church-scroll-cue {
  display: flex;
  width: fit-content;
  align-items: center;
  gap: 7px;
  margin: 22px auto 0;
  padding: 8px 12px;
  color: #86868b !important;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
}
.church-scroll-cue:hover {
  color: #1d1d1f !important;
}
.church-film {
  margin: 45px 0 0 !important;
}
.church-film video {
  display: block;
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: contain;
  background: #f5f5f7;
  border-radius: 24px;
  box-shadow: 0 18px 70px #0000000c;
}
.church-film figcaption {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  padding: 15px 4px;
  font-size: 12px;
  color: #646469;
  text-align: left;
}
.church-section {
  padding: 85px 0;
  border-top: 1px solid #e5e5e7;
}
.church-page h2 {
  font-size: clamp(36px, 4.9vw, 56px);
  line-height: 1.08;
  letter-spacing: -0.05em;
  font-weight: 600;
  margin: 18px 0 24px;
}
.church-page h3 {
  font-size: 23px;
  letter-spacing: -0.03em;
  font-weight: 600;
  line-height: 1.25;
}
.church-values {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
}
.church-values-copy h3 {
  font-size: 32px;
  margin: 20px 0;
}
.church-values-copy p + p {
  margin-top: 18px;
}
.church-text-link {
  display: inline-flex;
  gap: 20px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  margin-top: 24px;
}
.church-text-link:hover {
  text-decoration: underline;
}
.church-benchmark {
  display: grid;
  grid-template-columns: 1fr 1.18fr;
  gap: 48px;
  align-items: center;
}
.church-benchmark-copy > p:not(.church-eyebrow) {
  margin-top: 20px;
}
.church-test-record {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 12px;
  margin-top: 24px;
}
.church-page .cb-compass {
  margin: 0;
}
.church-page .cb-compass figcaption {
  font-size: 11px;
  margin: 4px 28px;
}
.church-page .cb-compass figcaption strong,
.church-page .cb-compass figcaption span {
  display: block;
}
.church-section-head {
  max-width: 660px;
}
.church-section-head > p:last-child {
  font-size: 18px;
}
.church-work-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  margin-top: 40px;
}
.church-work-grid article {
  padding: 32px;
  border-radius: 22px;
  background: #f5f5f7;
}
.church-number {
  color: #747479;
  font-size: 12px;
}
.church-work-grid h3 {
  margin: 48px 0 18px;
}
.church-work-grid p {
  font-size: 15px;
}
.church-work-tags {
  margin-top: 28px !important;
  font-size: 11px !important;
  color: #515155 !important;
}
.church-organization {
  scroll-margin-top: 30px;
}
.church-org-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 70px;
  align-items: center;
  margin: 45px 0;
}
.church-org-preview {
  padding: 28px;
  border: 1px solid #e5e5e7;
  border-radius: 24px;
  box-shadow: 0 18px 60px #00000008;
}
.church-preview-top {
  display: flex;
  gap: 12px;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
}
.church-demo-label {
  margin-left: auto;
  color: #747479;
  font-size: 10px;
  font-weight: 400;
}
.church-pool {
  background: #f5f5f7;
  border-radius: 16px;
  padding: 25px;
  margin: 26px 0 12px;
}
.church-pool > span {
  font-size: 12px;
  color: #646469;
}
.church-pool strong {
  display: block;
  font-size: 30px;
  line-height: 1.15;
  letter-spacing: -0.04em;
  margin: 14px 0 22px;
}
.church-pool-bar {
  display: flex;
  gap: 4px;
  height: 8px;
  margin-bottom: 12px;
}
.church-pool-bar i {
  flex: 1;
  background: #1d1d1f;
  border-radius: 2px;
}
.church-pool-bar i:nth-child(2) {
  background: #86868b;
}
.church-pool-bar i:nth-child(3) {
  background: #d2d2d7;
}
.church-pool small {
  font-size: 11px;
  color: #646469;
}
.church-member {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  padding: 14px 0;
  border-bottom: 1px solid #eee;
}
.church-member:last-child {
  border: 0;
}
.church-member > span:last-child {
  margin-left: auto;
  color: #646469;
  font-size: 11px;
}
.church-avatar {
  display: grid;
  place-items: center;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background: #f5f5f7;
  font-size: 11px;
}
.church-org-features {
  display: grid;
  gap: 26px;
}
.church-org-features h3 {
  font-size: 19px;
  margin-bottom: 8px;
}
.church-org-features p {
  font-size: 14px;
}
.church-org-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  background: #f5f5f7;
  padding: 28px;
  border-radius: 18px;
}
.church-org-bottom strong {
  font-size: 19px;
  letter-spacing: -0.02em;
}
.church-org-bottom p {
  font-size: 13px;
  margin-top: 7px;
}
.church-org-bottom .church-cta {
  flex-shrink: 0;
}
.church-faq {
  display: grid;
  grid-template-columns: 0.8fr 1.2fr;
  gap: 70px;
}
.church-faq details {
  border-bottom: 1px solid #e5e5e7;
  padding: 22px 0;
}
.church-faq details:first-child {
  padding-top: 0;
}
.church-faq summary {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  list-style: none;
}
.church-faq summary::-webkit-details-marker {
  display: none;
}
.church-faq details[open] summary span {
  transform: rotate(45deg);
}
.church-faq details p {
  padding-top: 18px;
  font-size: 14px;
}
.church-close {
  text-align: center;
  border-top: 1px solid #e5e5e7;
  padding: 90px 0 110px;
}
.church-close p:not(.church-eyebrow) {
  max-width: 520px;
  margin: auto;
  font-size: 18px;
}
.church-page a:focus-visible,
.church-page summary:focus-visible {
  outline: 2px solid #1d1d1f;
  outline-offset: 5px;
}
@media (max-width: 800px) {
  .church-content {
    padding: 0 24px;
  }
  .church-hero {
    padding-top: 110px;
  }
  .church-values,
  .church-benchmark,
  .church-org-layout,
  .church-faq {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  .church-work-grid {
    grid-template-columns: 1fr;
  }
  .church-work-grid h3 {
    margin-top: 24px;
  }
  .church-section {
    padding: 60px 0;
  }
  .church-org-bottom {
    align-items: flex-start;
    flex-direction: column;
  }
  .church-film figcaption {
    flex-direction: column;
    gap: 5px;
  }
  .church-film video {
    border-radius: 16px;
  }
  .church-page .cb-compass {
    max-width: 600px;
    width: 100%;
    margin: auto;
  }
  .church-close {
    padding: 65px 0 80px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .church-scroll {
    scroll-behavior: auto;
  }
  .church-cta {
    transition: none;
  }
}

.church-library-tools {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 28px 40px;
}
.church-library-tools h3 {
  margin: 0 0 10px;
  font-size: 19px;
  letter-spacing: -0.4px;
}
.church-library-tools p {
  color: #6e6e73;
  font-size: 15px;
  line-height: 1.65;
  margin: 0;
}
.church-library-prompts {
  max-width: none;
  margin: 44px 0 0;
}
.church-library-prompts details {
  padding-bottom: 22px;
}
.church-library-prompts a {
  color: #0066cc;
  font-size: 14px;
  text-decoration: none;
}
.church-related {
  padding: 48px 0 0;
  border-top: 1px solid #e7e7eb;
  display: flex;
  flex-wrap: wrap;
  gap: 16px 28px;
  align-items: center;
}
.church-related > p {
  width: 100%;
}
.church-related > a {
  color: #0066cc;
  text-decoration: none;
  font-size: 16px;
}
@media (max-width: 600px) {
  .church-library-tools {
    grid-template-columns: 1fr;
    gap: 28px;
  }
}
